export function calculateCoefficientVariation(array: number[]): number {
  const mean = array.reduce((acc, val) => acc + val, 0) / array.length;
  const squaredDifferences = array.map(num => Math.pow(num - mean, 2));
  const variance = squaredDifferences.reduce((acc, val) => acc + val, 0) / array.length;
  const stdDeviation = Math.sqrt(variance);
  return (stdDeviation / mean) * 100;
}
